import { call, put } from "redux-saga/effects";
import { setLoading } from "../actions/utils.actions";
import { show } from "../../services/alert";
import { apiCatalog as api } from "../../services/api";
import { setSpecialist, setSpecialties } from "../actions/specialist.actions";

export function* getAllDoctors({ payload }) {
  console.log("PAYLOADD", payload);
  yield put(setLoading(true));

  try {
    const url =
      payload.specialty && payload.specialty !== ""
        ? `/specialists/public?health_insurance_plan=${process.env.REACT_APP_HEALTH_INSURANCE_PLAN_SPECIALIST}&limit=10&page=${payload.page}&specialty=${payload.specialty}`
        : `/specialists/public?health_insurance_plan=${process.env.REACT_APP_HEALTH_INSURANCE_PLAN_SPECIALIST}&limit=10&page=${payload.page}`;

    const request = () => api.get(url);

    const specialist = yield call(request);

    if (specialist) {
      yield put(setSpecialist(specialist.data.data));
    }
  } catch (error) {
    show(error.response.data.message);
  } finally {
    yield put(setLoading(false));
  }
}

export function* getAllSpecialties() {
  yield put(setLoading(true));

  try {
    const request = () => api.get("/specialties?active=true&limit=0");
    const specialties = yield call(request);

    if (specialties && specialties.data) {
      yield put(setSpecialties(specialties.data));
    }
  } catch (error) {
    show(error.response.data.message);
  } finally {
    yield put(setLoading(false));
  }
}
